import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {TransactionsComponent} from './transactions.component';


const routes: Routes = [
    {
        path: 'transactions',
        data: {
            title: 'Transactions'
          },
        children: [
        { path: 'list', component: TransactionsComponent},
        ]
    }

];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })

export class TransactionsRoutingModule { }
